import axios from "axios";

export default function SafetyDownloadReportService() {
  return axios.get(process.env.REACT_APP_API_HOST + "/report/occupational_safety", {
    responseType: 'blob',
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  })
};
